import { render, staticRenderFns } from "./ControlePrioridadeJusBr.vue?vue&type=template&id=2bf71c6a&scoped=true&"
import script from "./ControlePrioridadeJusBr.vue?vue&type=script&lang=js&"
export * from "./ControlePrioridadeJusBr.vue?vue&type=script&lang=js&"
import style0 from "./ControlePrioridadeJusBr.vue?vue&type=style&index=0&id=2bf71c6a&scoped=true&lang=css&"
import style1 from "./ControlePrioridadeJusBr.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf71c6a",
  null
  
)

export default component.exports